import Tutorial from './Tutorial';
import common from '../../common';
import {translate} from '../../utils';
import RepeatCommand from '../../commands/RepeatCommand';

export default class TutorialLevel9 extends Tutorial {
	constructor(finger, panel, scene, commands) {
		super(finger, panel, scene, commands);
	}

	update() {
		super.update();
	}

	play() {
		super.play();

		if (this._destroyed) {
			return;
		}

		this.tweens.removeAll();

		let lastTween = null;

		if (this.stage === 0) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set(((common.STAGE_WIDTH * 0.5) + 60) - this._commands.ui.x, 130);
			common.focusOverlay.focusSprite(this._commands.ui.add, true);

			this._commands.commands[1].canChangeVariable = false;
			this._commands.toolboxItems[0].ui.interactive = false;

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE9.OPEN_TOOLS');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 1) {
			const focusWidth = common.STAGE_WIDTH * 0.5 - (common.STAGE_WIDTH - P3.View.width) * 0.5 + 240;
			common.focusOverlay.setFocus(20, 10, focusWidth, 275);

			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 150, 200);
			this._commands.ui.interactiveChildren = true;
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE9.DRAG_JUMP');
			this.signals.update.dispatch();

			this._commands.ui.add.interactive = false;

			const t1 = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					x : ((common.STAGE_WIDTH - P3.View.width) * 0.5) + 200,
					y : [300, 190]
				}, 750)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.interpolation(P3.utils.TWEEN.Interpolation.Bezier)
				.delay(500)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					alpha: 0
				}, 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None);

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 2) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set(((common.STAGE_WIDTH * 0.5) + 50) - this._commands.ui.x, 140);
			common.focusOverlay.focusSprite(this._commands.ui.add, true);
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE9.OPEN_TOOLS_AGAIN');
			this.signals.update.dispatch();

			this._commands.ui.add.interactive = true;
			this._commands.commands[1].commands[0].locked = true;
			this._commands.commands[1].commands[0].canChangeVariable = false;
			this._commands.toolboxItems[0].ui.interactive = true;
			this._commands.toolboxItems[1].ui.interactive = false;
			this._commands.toolboxItems[1].interactive = false;
			this._commands.toolboxItems[1].interactiveChildren = false;

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 3) {
			const focusWidth = common.STAGE_WIDTH * 0.5 - (common.STAGE_WIDTH - P3.View.width) * 0.5 + 240;
			common.focusOverlay.setFocus(20, 10, focusWidth, 275);

			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._commands.ui.interactive = true;
			this._commands.ui.interactiveChildren = true;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) - 80, 200);
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE9.DRAG_WALK');
			this.signals.update.dispatch();

			this._commands.ui.add.interactive = false;
			this._commands.toolboxItems[0].ui.interactive = true;

			const t1 = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					x : ((common.STAGE_WIDTH - P3.View.width) * 0.5) + 200,
					y : [300, 250]
				}, 750)
				.easing(P3.utils.TWEEN.Easing.Quadratic.InOut)
				.interpolation(P3.utils.TWEEN.Interpolation.Bezier)
				.delay(500)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					alpha: 0
				}, 500)
				.easing(P3.utils.TWEEN.Easing.Linear.None);

			t1.onComplete(() => lastTween.start());
		} else if (this.stage === 4) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 280, 140);
			common.focusOverlay.setFocus(20, 60, 380, 215);
			this._panel.label.text = translate('GAME.TUTORIAL.STAGE9.TAP_VARIABLES');
			this.signals.update.dispatch();

			this._commands.commands[1].canChangeVariable = true;
			this._commands.commands[1].commands[1].locked = true;
			this._commands.commands[1].commands[1].canChangeVariable = false;
			this._commands.commands[1].commands[0].canChangeVariable = false;

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 5) {
			this._finger.rotation = 0;
			this._finger.scale.set(1, 1);
			this._finger.alpha = 1;
			this._finger.position.set(((common.STAGE_WIDTH - P3.View.width) * 0.5) + 420, 130);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE9.TAP_VARIABLES');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => {
				return lastTween.start();
			});
		} else if (this.stage === 6) {
			this._finger.rotation = 0;
			this._finger.scale.set(1);
			this._finger.alpha = 1;
			this._finger.position.set((common.STAGE_WIDTH * 0.5) + 100 - this._commands.ui.x, common.STAGE_HEIGHT - 210);
			common.focusOverlay.focusSprite(this._scene.runButton, true);

			this._panel.label.text = translate('GAME.TUTORIAL.STAGE9.RUN');
			this.signals.update.dispatch();

			const t1 = new P3.utils.TWEEN.Tween(this._finger.scale, this.tweens)
				.to({
					x : 0.85,
					y : 0.85
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			lastTween = new P3.utils.TWEEN.Tween(this._finger, this.tweens)
				.to({
					rotation: -15 * PIXI.DEG_TO_RAD
				}, 300)
				.easing(P3.utils.Easing.Back2.Out)
				.yoyo(true)
				.repeat(1)
				.start();

			t1.onComplete(() => lastTween.start());
		}

		if (lastTween) {
			lastTween.onComplete(() => {
				P3.utils.delayg(this.tweens, 0.5, () => {
					this.play();
				});
			});
		}
	}

	stop() {
		super.stop();
	}

	prepareCommands() {
		super.prepareCommands();

		for (let i = 0; i < 1; i++) {
			const command = new RepeatCommand();

			command.template = false;
			command.grabbable = false;
			command.locked = true;
			command.placed = true;
			this._commands.commandContainer.addChild(command);
			command.x = 169;
			command.setText(command.defaultVariable);
			for (const comm of this._commands.commands) {
				comm.slotPosition.set(comm.position.x, comm.position.y);
			}

			this._commands.commands.splice(i + 1, 0, command);
			this._commands.resize();

			command.interactive = true;
			command.signals.pickup.detachAll();
			command.variable = command.defaultVariable;
			command.signals.touch.add(this._commands.onCommandTouch, this._commands);
			command.signals.onVariableTouch.add(this._commands.onVariableTouch, this._commands);
		}
	}
}
